<template>
	<div>
		<LaptopProfile v-if="isLaptop" />
		<MobileProfile v-else />
	</div>
</template>

<script>
import LaptopProfile from "../Profile.vue";
import MobileProfile from "../../components/MobileComponents/Profile.vue";
export default {
	name: "Dashboard",
	components: {
		LaptopProfile,
		MobileProfile,
	},
	data() {
		return {
			isLaptop: true,
		};
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
		console.log("mount");
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
	},
};
</script>

<style></style>
